import React from 'react';
import styles from './stickies.module.scss';

function StickyDetailsLine({ name, category, value }) {
  return (
    <div className={styles.detail}>
      <div className={styles.firstRow}>
        <span className={styles.name}>{name}</span>
        <span className={styles.value}>{value}</span>
      </div>
      <span className={styles.category}>{category}</span>
    </div>
  );
}

function StickyDetails({ details, tablet, ...props }) {
  return (
    <div className={`${styles.stickyDetails} ${tablet ? styles.tablet : ''}`}>
      {details.map(details => (
        <StickyDetailsLine
          key={details.title}
          name={details.title}
          category={details.category}
          value={details.value}
        />
      ))}
    </div>
  );
}
export default StickyDetails;
